// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2WqdD","row":"Node_row__3F0_k","label":"Node_label__24HP-","footer":"Node_footer__3HzK2"};